
import {defineComponent, PropType} from 'vue';
import Topbar from '@ohrm/oxd/core/components/Topbar/Topbar.vue';
import SidePanel from '@ohrm/oxd/core/components/SidePanel/SidePanel.vue';
import overlay from '@ohrm/oxd/core/components/Dialog/Overlay.vue';
import MenuItem from '../SidePanel/types';
import {TopMenuItem, User, Breadcrumb} from '../Topbar/types';

export default defineComponent({
  name: 'oxd-layout',

  props: {
    user: {
      type: Object as PropType<User>,
    },
    sidepanelMenuItems: {
      type: Object as PropType<MenuItem[]>,
      required: true,
    },
    topbarMenuItems: {
      type: Object as PropType<TopMenuItem[]>,
      required: true,
    },
    brandLogoSrc: {
      type: String,
      required: true,
    },
    brandBannerSrc: {
      type: String,
      required: true,
    },
    homeUrl: {
      type: String,
      default: '/',
    },
    breadcrumb: {
      type: Object as PropType<Breadcrumb>,
      required: true,
    },
  },

  components: {
    'oxd-side-panel': SidePanel,
    'oxd-top-bar': Topbar,
    'oxd-overlay': overlay,
  },

  data() {
    return {
      collapse: false,
    };
  },

  methods: {
    onCollapse() {
      this.collapse = !this.collapse;
    },
  },

  computed: {
    containerClasses(): object {
      return {
        'oxd-layout-container': true,
        '--collapse': this.collapse,
      };
    },
  },
});
